import { render, staticRenderFns } from "./CatchFishType.vue?vue&type=template&id=5cef9c7f&scoped=true&"
import script from "./CatchFishType.vue?vue&type=script&lang=js&"
export * from "./CatchFishType.vue?vue&type=script&lang=js&"
import style0 from "./CatchFishType.vue?vue&type=style&index=0&id=5cef9c7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cef9c7f",
  null
  
)

export default component.exports